import React from 'react';
import male from '../assets/male-big.png';
import { Allocation } from 'service/dto/allocation.dto';
import { format } from 'date-fns';
import { BeneficiaryTypeEnum } from 'apps/user/types/user.enum.type';

type Props = {
  allocation: Allocation;
};

export default function BeneficiaryDetails({ allocation }: Props) {
  return (
    <div>
      <div className="mb-5 flex flex-row rounded border border-[#E5E5E5] bg-white">
        <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
          <div className="mr-2 flex w-40 flex-col items-center justify-center">
            <img src={male} />
          </div>
        </div>
        <div className="w-full">
          <div className="border-b border-[#E5E5E5]">
            <div className="grid grid-cols-4 gap-x-16  px-4">
              <div className="col-span-1 px-8 py-6">
                <p className="text-[10px] font-normal text-[#7A7C87]">Name</p>
                <p className="mt-1 text-sm font-normal text-[#353535]">
                  {`${allocation.beneficiary.beneficiaryFirstName} ${allocation.beneficiary.beneficiaryMiddleName} ${allocation.beneficiary.beneficiaryLastName}`}
                </p>
              </div>
              {allocation.beneficiary.beneficiaryType ===
                BeneficiaryTypeEnum.INDIVIDUAL && (
                <div className="col-span-1 px-5 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Date of Birth
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {allocation.beneficiary
                      ? format(
                          new Date(allocation.beneficiary.dateOfBirth),
                          'dd MMMM yyyy'
                        )
                      : 'Unknown'}
                  </p>
                </div>
              )}
              {allocation.beneficiary.beneficiaryType ===
                BeneficiaryTypeEnum.CORPORATE && (
                <div className="col-span-1 px-8 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Incorporation Date
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {allocation.beneficiary
                      ? format(
                          new Date(allocation.beneficiary.incorporationDate),
                          'dd MMMM yyyy'
                        )
                      : 'Unknown'}
                  </p>
                </div>
              )}

              <div className="col-span-1 px-5 py-6">
                <p className="text-[10px] font-normal text-[#7A7C87]">
                  Percentage Alloted
                </p>
                <p className="mt-1 text-sm font-normal text-[#353535]">
                  {allocation.allottedPercentage}%
                </p>
              </div>
              {allocation.beneficiary.beneficiaryType ===
                BeneficiaryTypeEnum.INDIVIDUAL && (
                <div className="col-span-1 px-5 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Relationship
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {allocation.beneficiary.relationship}
                  </p>
                </div>
              )}
              {allocation.beneficiary.beneficiaryType ===
                BeneficiaryTypeEnum.CORPORATE && (
                <div className="col-span-1 px-8 py-6">
                  <p className="text-[10px] font-normal text-[#7A7C87]">
                    Rc Number
                  </p>
                  <p className="mt-1 text-sm font-normal text-[#353535]">
                    {allocation.beneficiary?.rcNumber || 'Unknown'}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="grid grid-cols-4 gap-x-16 px-6">
            {allocation.beneficiary.beneficiaryType ===
              BeneficiaryTypeEnum.INDIVIDUAL && (
              <div className="col-span-1 px-5 py-6">
                <p className="text-[10px] font-normal text-[#7A7C87]">
                  Marital Status
                </p>
                <p className="mt-1 text-sm font-normal text-[#353535]">
                  {allocation.beneficiary.maritalStatus}
                </p>
              </div>
            )}

            <div className="col-span-1 px-5 py-6">
              <p className="text-[10px] font-normal text-[#7A7C87]">
                Phone Number
              </p>
              <p className="mt-1 text-sm font-normal text-[#353535]">
                08035911412
              </p>
            </div>
            <div className="col-span-1 px-5 py-6">
              <p className="mt-1 text-[10px] font-normal text-[#7A7C87]">
                Email address
              </p>
              <p className="text-sm font-normal text-[#353535]">
                {allocation.beneficiary.emailAddress}
              </p>
            </div>
            <div className="col-span-1 px-5 py-6">
              <p className="mt-1 text-[10px] font-normal text-[#7A7C87]">
                Address
              </p>
              <p className="text-sm font-normal text-[#353535]">
                {allocation.beneficiary.address}
              </p>
            </div>
            {allocation.beneficiary.beneficiaryType ===
              BeneficiaryTypeEnum.CORPORATE && (
              <div className="col-span-1 px-5 py-6">
                <p className="mt-1 text-[10px] font-normal text-[#7A7C87]">
                  Address
                </p>
                <p className="text-sm font-normal text-[#353535]">
                  {allocation.beneficiary.incorporationPlace}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
